export default {
  data() {
    return {
      result: {
        total: 16,
        pageSize: 15,
        current: 1,
        records: [
          {
            id: 'user1',
            name: 'John Brown',
            amount: 1000000,
            status: 1,
            description:
              ' My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.',
          },
          {
            id: 'user2',
            name: 'Jim Black BlackBlackBlack',
            amount: 23400000,
            status: 2,
            description:
              ' My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.',
          },
          {
            id: 'user3',
            name: 'Jim Black',
            amount: 23400000,
            status: 3,
            description:
              ' My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.',
          },
          {
            id: 'user4',
            name: 'Jim Black',
            amount: 23400000,
            status: 4,
            description:
              ' My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.',
          },
        ],
      },
      //column
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          // title: '用户名111',
          dataIndex: '股东',
          key: 'shareholderName',
          slots: { title: 'shareholderName' },
        },
        {
          title: '股东类型',
          dataIndex: 'shareholderType',
          key: 'shareholderType',
        },
        {
          title: '认缴日期',
          dataIndex: 'subscribedCapital',
          key: 'subscribedCapital',
        },
        {
          title: '认缴出资（万元）',
          dataIndex: 'subscribedCapital',
          key: 'subscribedCapital',
          scopedSlots: { customRender: 'subscribedCapital' },
          ellipsis: true,
        },
        {
          title: '占股比例',
          dataIndex: 'shareRatio',
          key: 'shareRatio',
        },
        {
          title: '实缴金额（万元）',
          dataIndex: 'actualPaymentAmount',
          key: 'actualPaymentAmount',
        },
        {
          title: '实缴出资时间',
          key: 'actualContributionTime',
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
